import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const createVideoAction = createAsyncThunk(
    'create-video',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/createVideo`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createVideoSlice = createSlice({
    name: 'create-video',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createVideoAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createVideoAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
               
            })
            builder.addCase(createVideoAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createVideoReducer = createVideoSlice.reducer